<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Duties and Responsibilities</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="dutiesRes.code"
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="dutiesRes.desc"
            ></v-text-field>
          </v-col> -->
        </v-row>
        <v-row>
          <v-col>
            <quill-editor
              v-model="dutiesRes.desc"
              :options="editorOption"
            ></quill-editor>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>
      <!-- 
      <pagination :show-dense="false" :show-select="true"></pagination>-->
      <!-- <router-view /> -->

      <v-dialog v-model="editDialog" width="700" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Edit</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Code"
                  :class="classPadding"
                  v-model="editDutiesRes.code"
                  disabled
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Description"
                  :class="classPadding"
                  v-model="editDutiesRes.desc"
                ></v-text-field>
              </v-col> -->
            </v-row>
            <v-row>
              <v-col>
                <quill-editor
                  v-model="editDutiesRes.desc"
                  :options="editorOption"
                ></quill-editor>
              </v-col>
            </v-row>
            <!-- <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn color="success" :loading="isSaving" :class="classPadding" @click.stop="save">Save</v-btn>
          </v-col>
            </v-row>-->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click.stop="editDialog = false"
              >Close</v-btn
            >
            <v-btn
              text
              color="success"
              @click.stop="update"
              :loading="isUpdating"
              v-if="userAccess.update >= 1"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import List from "./List";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
// import Pagination from "./PaginationSelection";
const API_ENDPOINT = "/api/dutiesRes";
export default {
  metaInfo: {
    title: "Duties and Responsibilities",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
  },
  mixins: [userAccessMixin],
  components: {
    List,
    quillEditor,
    // Pagination
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    isUpdating: false,
    dutiesRes: {},
    componentKey: 0,
    editDutiesRes: {},
    editDialog: false,
    editorOption: {
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ size: ["small", false, "large", "huge"] }], // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ],
      },
      //   theme: "snow",
      //   modules: {
      //     toolbar: false
      //   }
    },
  }),
  methods: {
    // ...mapActions("movementTypeDetails", ["selectMovementTypeDetails"]),
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}`, this.dutiesRes)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      var rel = Object.assign({}, item);
      this.editDutiesRes.code = rel.dutiesResponsibilitiesCode;
      this.editDutiesRes.desc = rel.dutiesResponsibilitiesDesc;
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete",
      }).then((res) => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.dutiesResponsibilitiesCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.dutiesRes = {};
      this.forceRerender();
      this.editDialog = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;

      this.$axios
        .put(`${API_ENDPOINT}`, this.editDutiesRes)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
  },
  created() {
    this.getUserAccessRights("DutAndRes");
  },
};
</script>
